const getAnchor = (text) => text.toLowerCase().replace(/[^\p{L}\p{N}]+/gu, '-');

export default getAnchor;
